import React from 'react';

import { TicketKey } from 'flow/types/EntityKeys';
import useTicketFetchOnTicketViewMount from 'flow/hooks/useTicketFetchOnTicketViewMount';

import PopoverBody from 'flow/components/tickets/OverviewPopover/PopoverBody';

interface Props {
    ticketKey: TicketKey;
    onClose: () => void;
    segmentContext?: string;
}

const TicketOverviewPopover = ({
    ticketKey,
    onClose,
    segmentContext,
}: Props) => {
    const { accessToTicketMissing, isFetchingTicket } =
        useTicketFetchOnTicketViewMount(ticketKey);

    return (
        <PopoverBody
            open={true}
            onClose={onClose}
            ticketKey={ticketKey}
            accessToTicketMissing={accessToTicketMissing}
            isLoading={isFetchingTicket}
            segmentContext={segmentContext}
        />
    );
};

export default React.memo(TicketOverviewPopover);
